<form [formGroup]="pertinenceForm" class="form-container" (ngSubmit)="onSubmit()">
  <fieldset class="form-fieldset">
    <legend class="custom-legend">Pertinence de l'existence de l'emploi</legend>
    <div class="form-group">
      <div class="d-flex col-12 flex-column">
        <div class="row full-width">
          <label for="pertinenceMission">Pertinence des missions *</label>
          <div class="form-text mb-1">Décrivez pertinence des missions.</div>
          <mat-form-field class="expandable-textarea">
            <textarea style="height: 100px" [placeholder]="nbreCaratereTextarea1" matInput
            formControlName="pertinenceMission"></textarea>
            @if (pertinenceForm.get('pertinenceMission')?.hasError('required') || pertinenceForm.get('pertinenceMission')?.hasError('whitespace') && pertinenceForm.get('pertinenceMission')?.touched) {
              <mat-error
                >
                Ce champ ne peut pas être vide ou contenir uniquement des espaces.
              </mat-error>
            }
            @if (pertinenceForm.get('pertinenceMission')?.hasError('maxLengthExceeded')) {
              <mat-error>
                Le texte ne doit pas dépasser 350 caractères
              </mat-error>
            }
          </mat-form-field>
          <label for="renouvellementJustifie">Renouvellement à justifier *</label>
          <div class="form-text mb-1">Décrivez le renouvellement.</div>
          <mat-form-field class="expandable-textarea">
            <textarea style="height: 100px" matInput [placeholder]="nbreCaratereTextarea2"
            formControlName="renouvellementJustifie"></textarea>
            @if (
              pertinenceForm.get('renouvellementJustifie')?.hasError('required') || pertinenceForm.get('renouvellementJustifie')?.hasError('whitespace') && pertinenceForm.get('renouvellementJustifie')?.touched
              ) {
              <mat-error>
                Ce champ ne peut pas être vide ou contenir uniquement des espaces.
              </mat-error>
            }
            @if (pertinenceForm.get('renouvellementJustifie')?.hasError('maxLengthExceeded')) {
              <mat-error>
                Le texte ne doit pas dépasser 720 caractères
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <div class="download-container" [class.dragging]="isDragging" (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)" (drop)="handleDragDrop($event)">
        <label style="color: dimgray">Glissez-déposez les fichiers ici</label>
        <mat-icon color="primary">upload</mat-icon>
        <input type="file" #fileInput (change)="onFileSelected($event)" accept="application/pdf" multiple hidden
          required />
          <button mat-flat-button color="primary" (click)="triggerFileInput(fileInput)">Ou cliquez ici pour sélectionner
          les fichiers</button>
          @if (invalidFile) {
            <mat-error>Seuls les fichiers PDF sont autorisés.</mat-error>
          }
          @if (invalidFile) {
            <mat-error> Seuls les fichiers PDF sont autorisés. </mat-error>
          }

          @if (isFileRequired && pertinenceForm.get('files')?.invalid) {
            <mat-error>
              La pièce jointe est obligatoire pour ce motif.
            </mat-error>
          }
        </div>

        @if (selectedFileNames.length > 0) {
          <div class="file-name">
            <mat-chip-set class="custom-chip-list">
              @for (fileName of selectedFileNames; track fileName; let i = $index) {
                <mat-chip class="custom-chip"
                  (removed)="removeFile(i)">
                  {{ fileName.name }}
                  <button matChipRemove aria-label="Supprimer la pièce jointe">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip>
              }
            </mat-chip-set>
          </div>
        }

        <div class="file-size-warning">
          <p>
            La taille maximale d'un fichier ne doit pas dépasser <strong>300 MO *</strong><br />
            Seuls les fichiers au format <strong>PDF</strong> sont acceptés * <br />
            <span class="fichier-recommande">Il est obligatoire de joindre le profil de poste et l'organigramme
            souhaités.</span>
          </p>
        </div>
      </div>
    </fieldset>
    <!-- btns -->
    <div class="button-group">
      <button mat-stroked-button type="button" (click)="onReset()"><mat-icon>autorenew</mat-icon>Réinitialiser</button>
      <button mat-stroked-button type="button" matStepperPrevious><mat-icon>undo</mat-icon>Précédent</button>
      <button mat-flat-button color="primary" type="submit" matStepperNext
        [disabled]="!pertinenceForm.valid || isNextButtonDisabled">
        Suivant
      </button>
    </div>
  </form>
